import { Divider, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useContext, useEffect } from "react";

import { NotificationsContext } from "@contexts/Notifications/context";
import { NotificationItem } from "./NotificationItem";
import * as S from "./styles";

interface Props {
  onClose: () => void;
}

export function NotificationsPopover({ onClose }: Props) {
  const { notifications, markAsRead } = useContext(NotificationsContext);

  useEffect(() => {
    notifications.filter((n) => !n.read).forEach((n) => markAsRead(n.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.PopoverContent>
      <S.Header>
        <S.TitleWrapper>
          <CloseOutlined onClick={onClose} style={{ cursor: "pointer" }} />

          <Typography.Title level={5} style={{ margin: 0 }}>
            Notificações
          </Typography.Title>
        </S.TitleWrapper>
      </S.Header>

      <Divider style={{ margin: "8px 0" }} />

      {notifications.length === 0 ? (
        <Typography.Text type="secondary">
          Nenhuma notificação no momento
        </Typography.Text>
      ) : (
        notifications.map((notification) => (
          <NotificationItem key={notification.id} notification={notification} />
        ))
      )}
    </S.PopoverContent>
  );
}
